import {GROUP_TYPE, GROUP_SECTION_WIDTH /*, createCacheCanvas*/, drawRectangle} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import Util from '../../../../forecast-app/shared/util/util';

class PlaceholderGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PLACEHOLDER, data);
	}

	draw(canvasContext, x, y) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, groupType} = this;
		super.draw(x, y, width, height, this);
		const {id} = data;
		const cacheId = `${groupType}-${id}`;
		const cachedData = cacheManager.get(groupType, cacheId);

		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			return;
		}

		/*const drawCacheablePart = () => {
			const cacheCanvas = createCacheCanvas(width, this.itemRowHeight);
			const context = cacheCanvas.getContext('2d');
			drawRectangle(context, data.xOffset, -1, width - data.xOffset, height + 1, {
				borderColor: '#ebebee',
				borderThickness: 1,
				backgroundColor: '#ffffff'
			});
			context.font = '14px ' + Util.getFontFamily();
			context.fillStyle = '#a1a1a1';
			context.font = 'italic 12px ' + Util.getFontFamily();
			context.fillText(data.name, 24, 18);
			context.font = '14px ' + Util.getFontFamily();
			cacheManager.set(groupType, cacheId, cacheCanvas);
			canvasContext.drawImage(cacheCanvas, x, y, width, this.itemRowHeight);
		};
		drawCacheablePart();*/
		drawRectangle(canvasContext, x + data.xOffset, y - 1, width - data.xOffset, height + 1, {
			borderColor: '#ebebee',
			borderThickness: 1,
			backgroundColor: '#ffffff',
		});
		canvasContext.font = '14px ' + Util.getFontFamily();
		canvasContext.fillStyle = '#a1a1a1';
		canvasContext.font = 'italic 12px ' + Util.getFontFamily();
		canvasContext.fillText(data.name, x + 24, y + 18);
	}
}

export default PlaceholderGroup;
